import React, {Component} from 'react'
import BackOfficeFiltersComponent from '../components/BackOfficeFiltersComponent'
import { ReactDataGrid } from 'react-data-grid'

export default class BackOfficeParkingPassScreen extends Component {

  columns = [
    {key: 'id', name: 'ID', width:45},
    {key: 'userId', name: 'ID Utente', width: 50, resizable: true},
    {key: 'typeId', name: 'ID Tipo Abbonamento', resizable: true},
    {key: 'vehicleId', name: 'ID Veicolo', resizable: true},
    {key: 'startDate', name: 'Inizio Validità', resizable: true},
    {key: 'endDate', name: 'Fine Validità', resizable: true},
    {key: 'issueDate', name: 'Data di Emissione', resizable: true}
  ];

  rowGetter(i) {
    return this.props.parkingPasses[i]
  }

  render() {
    return(<div>
      <div className="btn-group">
        <div className="btn-group" role="group">
          <button type="button" className="btn btn-add" onClick={this.props.onCreateParkingPassClick}>
            <i className="glyphicon glyphicon-plus"></i>
            {} Abbonamento</button>
        </div>
      </div>
      <BackOfficeFiltersComponent />
      <ReactDataGrid
        enableCellSelect={true}
        columns={this.columns}
        rowGetter={this.rowGetter.bind(this)}
        rowsCount={this.props.parkingPasses.length}
        minHeight={400}
        emptyRowsView={() => <div>Nessun Abbonamento Presente</div>} />
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/screens/BackOfficeParkingPassScreen.js